export * from './keyStorage';
export * from './storageObserver';
export * from './webStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-webstorage/dist/helpers/index.js
// module id = 581
// module chunks = 3